// ** React Imports
import { useContext, useState } from 'react'

import DataTable from 'react-data-table-component'
import { ChevronDown, ChevronRight } from 'react-feather'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { Card } from 'reactstrap'
import { startLoadingTable } from '../../../redux/actions/list'
import { FilterContext } from '../../../utility/context/FilterContext'
import { useRedirect } from '../../../utility/hooks/useRedirect'
import { customStyles, customExpandableStyles } from './addons/CustomStyles'
import { TableHeader } from './TableHeader'
import { AbilityContext } from '@src/utility/context/Can'

const noResult = <span style={{ margin: '2%', width: '50%', textAlign: 'center' }}>No se han encontrado resultados</span>
const sortIcon = <ChevronDown size={10} />
const messagePagination = { rowsPerPageText: 'Registros por página', rangeSeparatorText: 'de', selectAllRowsItem: true, selectAllRowsItemText: 'Todos' }
const limit = [10, 25, 50, 100, 250]

const ExpandableTable = ({ columns, data }) => {
  return <><DataTable
    noTableHead={true}
    noHeader={true}
    pagination={false}
    responsive
    className='react-datatable'
    customStyles={customStyles}
    sortIcon={sortIcon}
    noDataComponent={noResult}
    columns={columns}
    data={data['child']}
  /><hr className="col-xl-12 border-black " /></>
}

const toLowerCaseFirstLetter = (str) => {
  return str.replace(/^\w/, (c) => c.toLowerCase())
}

export const CDataTable = (props) => {

  const pathname = useLocation().pathname
  const dispatch = useDispatch()
  const {
    columns,
    data = [],
    fakePoint,
    parentId = null,
    addPath = `${pathname}/add`,
    endPoint,
    expandable = false,
    expandableConfig = {},
    specification,
    params
  } = props


  // ** States
  const [filteredData, setFilteredData] = useState([])
  const [currentPage, setCurrentPage] = useState(0)
  const [searchGlobalValue, setGlobalSearchValue] = useState('')
  const [searchColumnValue, setColumnValue] = useState({})
  const [store, setStore] = useState(false)
  const [allExpanded, setAllExpanded] = useState(false)

  const redirect = useRedirect()
  const ability = useContext(AbilityContext)

  const realData = (Object.keys(searchColumnValue).length === 0 && searchGlobalValue.length === 0) ? data : filteredData

  const showStoredData = () => {
    if (params) {
      dispatch(startLoadingTable(endPoint, null, { ...params, extraUrl: `find/all`, where: { ...params.where, store: !store } }))
      setStore(!store)
    }
  }

  const handleRowDblClick = (e) => {
    if (ability.can('update', endPoint.toLowerCase())) redirect.redirectToEdit(e, specification)
  }

  const headerProps = {
    can: toLowerCaseFirstLetter(fakePoint ? fakePoint : endPoint),
    redirPath: !!parentId ? addPath.replace(':parentId', parentId) : addPath,
    realData,
    ...props
  }

  const expandAll = () => { setAllExpanded(true) }
  const collapseAll = () => { setAllExpanded(false) }

  return (
    <>
      <Card className='mb-0'>
        <FilterContext.Provider value={{
          setColumnValue,
          setFilteredData,
          setGlobalSearchValue,
          setCurrentPage,
          showStoredData,
          searchColumnValue,
          store
        }} >
          <TableHeader {...headerProps} />
        </FilterContext.Provider>
        {expandable && (
          <div className="flex flex-wrap justify-content-end gap-2 py-1 pl-1">
            {!allExpanded ? (
              <span className='text-primary cursor-pointer' onClick={expandAll}>
                <ChevronRight className='mr-1' size={10} />
                Expandir
              </span>
            ) : (
              <span className='text-primary cursor-pointer' onClick={collapseAll}>
                <ChevronDown className='mr-1' size={10} />
                Colapsar
              </span>
            )}
          </div>
        )}
        <DataTable
          className='react-dataTable'
          customStyles={expandable ? customExpandableStyles : customStyles}
          responsive
          noHeader
          sortIcon={sortIcon}
          onRowClicked={handleRowDblClick}

          noDataComponent={noResult}

          expandableRows={expandable}
          expandOnRowClicked={false}

          expandableRowExpanded={() => allExpanded}

          expandableRowsComponent={<ExpandableTable {...expandableConfig} data={realData} />}

          columns={columns}
          data={realData}

          pagination
          paginationPerPage={25}
          paginationDefaultPage={currentPage + 1}
          paginationComponentOptions={messagePagination}
          paginationRowsPerPageOptions={limit}
        />
      </Card>
    </>
  )
}